import React, { MouseEvent, useContext, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { GlobalContext } from "../Utils/Contexts";

interface ToolbarMenuProps {
    setAuthorizationToken(newToken: string): void;
    setPersonId(newPersonId: string): void;
}

export default function ToolbarMenu(props: ToolbarMenuProps): JSX.Element {
    const [anchorElement, setAnchorElement] = React.useState<HTMLButtonElement | null>(null);
    const [fallbackTest, setFallbackTest] = useState(false);

    if (fallbackTest) {
        // Triggers a react error by changing the hook order
        const [fallbackError, setFallbackError] = useState(false);
    }

    const open = Boolean(anchorElement);
    const context = useContext(GlobalContext);

    const handleClick = (event: MouseEvent) => {
        setAnchorElement(event.currentTarget as HTMLButtonElement);
    };

    const handleClose = () => {
        setAnchorElement(null);
    };

    const handleLogout = () => {
        setAnchorElement(null);
        props.setAuthorizationToken("");
        props.setPersonId("");
    };

    const handleErrorTest = () => {
        setTimeout(() => {
            handleClose();
        }, 100);

        throw "Error thrown to test remote logging.";
    };

    const handleFallbackTest = () => {
        setFallbackTest(true);
    };

    function handleReloadPage() {
        window.location.reload();
    }

    const adminUsers = [
        { first_name: "LAVERNE", last_name: "KELLY" },
        { first_name: "SEAN", last_name: "KELLY" },
        { first_name: "KIMBERLY", last_name: "KELLY" },
        { first_name: "MARK", last_name: "BANNAN" },
    ];

    const isAdminUser =
        adminUsers.findIndex((p) => {
            return (
                p.first_name.localeCompare(context.loggedInUser?.first_name?.toLocaleUpperCase() ?? "") == 0 &&
                p.last_name.localeCompare(context.loggedInUser?.last_name?.toLocaleUpperCase() ?? "") == 0
            );
        }) >= 0;

    return (
        <>
            <IconButton size="large" edge="start" color="inherit" aria-label="Menu Button" sx={{ ml: 2, mr: 2 }} onClick={handleClick}>
                <MenuIcon />
            </IconButton>
            <Menu
                anchorEl={anchorElement}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                }}>
                <MenuItem onClick={handleReloadPage}>CHECK FOR UPDATES</MenuItem>
                <MenuItem onClick={handleLogout}>LOGOUT</MenuItem>
                {isAdminUser && <MenuItem onClick={handleErrorTest}>TEST ERROR LOGGING</MenuItem>}
                {isAdminUser && <MenuItem onClick={handleFallbackTest}>TEST FALLBACK DIALOGUE</MenuItem>}
            </Menu>
        </>
    );
}
